module.exports = __webpack_public_path__ + "static/media/ss.2d934aec.jpg";